import type { LinkDescriptor, LinksFunction } from 'react-router';

const geistPreload: LinkDescriptor = {
  rel: 'preload',
  href: '/fonts/marketing/geist-v5-latin.woff2',
  as: 'font',
  type: 'font/woff2',
  crossOrigin: 'anonymous',
};

/** Preload the heading and body faces; CSS requests other subsets only when used. */
export const marketingFontLinks: LinksFunction = () => [
  {
    rel: 'preload',
    href: '/fonts/marketing/fraunces-v38-latin.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
  geistPreload,
];

/** Pages that keep the app's typography preload only the navigation's face. */
export const marketingNavFontLinks: LinksFunction = () => [geistPreload];
